import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface PublicPageTemplateProps {
  badge: string;
  title: string;
  highlight: string;
  description: string;
  children?: React.ReactNode;
}

export const PublicPageTemplate = ({ badge, title, highlight, description, children }: PublicPageTemplateProps) => (
  <PublicLayout>
    <section className="py-24 md:py-32">
      <div className="container">
        <p className="text-primary font-medium text-sm tracking-wider uppercase mb-6">{badge}</p>
        <h1 className="text-4xl md:text-6xl font-bold leading-tight tracking-tight mb-6">
          {title} <span className="text-gradient">{highlight}</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10">{description}</p>
        <div className="flex flex-wrap gap-4">
          <Link to="/auth">
            <Button variant="hero" size="lg">
              Commencer maintenant <ArrowRight className="ml-1" />
            </Button>
          </Link>
          <Link to="/diagnostic">
            <Button variant="hero-outline" size="lg">Diagnostic gratuit</Button>
          </Link>
        </div>
      </div>
    </section>
    {children}
  </PublicLayout>
);
